export default __webpack_public_path__ + "static/media/step2-grey.082af531.svg";